import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Plus } from "lucide-react";
import { useApp } from "../context/AppContext";
import { useToast } from "../hooks/use-toast";

const ProductCard = ({ product }) => {
  const { t, lang, addToCart } = useApp();
  const { toast } = useToast();
  const name = lang === "de" && product.name_de ? product.name_de : product.name;

  const handleAdd = () => {
    addToCart({ id: product.id, name, price: product.price, img: product.img, category: product.category });
    toast({ title: t("common.added"), description: name });
  };

  return (
    <div className="group bg-white rounded-2xl overflow-hidden border border-border hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col">
      <Link to={`/product/${product.id}`} className="relative overflow-hidden aspect-[4/5] bg-cream-dark block">
        <img src={product.img || "/logo_moc.png"} alt={name} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "/logo_moc.png"; }} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        <span className="absolute top-3 left-3 bg-cream/90 backdrop-blur text-wine text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full">
          {product.type === "red" ? t("store.red") : t("store.white")}
        </span>
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <Link to={`/product/${product.id}`}><h3 className="font-serif text-lg text-ink leading-tight hover:text-wine transition-colors">{name}</h3></Link>
        <p className="text-sm text-ink/60 mt-1 line-clamp-2 min-h-[2.5rem]">{product.desc?.[lang] || product.desc?.en}</p>
        <div className="flex items-center justify-between mt-4 pt-1">
          <span className="font-serif text-xl text-wine">{t("common.currency")} {Number(product.price).toFixed(2)}</span>
          <Button onClick={handleAdd} size="sm" className="bg-wine hover:bg-wine-dark text-white rounded-full gap-1">
            <Plus className="w-4 h-4" /> {t("common.addToCart")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
